module.exports = __webpack_public_path__ + "img/@.16e070ef.svg";